export enum DocumentPrintOrderType {
  OrderId,
  DocumentNumber,
}
